import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrize = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17.798 17.592",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Prize",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		children: [
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7222",
				d: "M9.912 1.03 1.133 9.81a.956.956 0 0 0 0 1.35l5.4 5.4a.955.955 0 0 0 1.35 0l8.779-8.779a.956.956 0 0 0 0-1.351l-5.4-5.4a.955.955 0 0 0-1.35 0Z",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7223",
				d: "M10.263 10.16a1.93 1.93 0 1 0-2.729 0 1.929 1.929 0 0 0 2.729 0Z",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7224",
				d: "M4.035 10.655a.241.241 0 0 1-.341-.341"
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7225",
				d: "M4.006 10.656a.241.241 0 1 0-.341-.341"
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7226",
				d: "M14.134 7.279a.241.241 0 1 1-.341-.341"
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 7227",
				d: "M14.104 7.28a.241.241 0 1 0-.341-.341"
			})
		]
	})
});
export { SvgPrize as ReactComponent };
